import DefaultAttr from './default'
export default class TextControl extends DefaultAttr {
  textContent = ''
  constructor (args = {}) {
    super(args)
    this._.assign(this, args)
    // 挂载背景颜色
    this.setStyleSetting(args.type, this)
  }
}



// WEBPACK FOOTER //
// ./src/components/report/design/customPage/assets/js/textControl.js